import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, switchMap } from 'rxjs';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AUTH_ENVIRONMENT } from '../models/environment.token';

@Injectable()
export class TokenInjector implements HttpInterceptor {
    private oidcSecurityService = inject(OidcSecurityService);
    private environment = inject(AUTH_ENVIRONMENT);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return this.oidcSecurityService.getIdToken().pipe(
            switchMap((token) => {
                if (token) {
                    const url = this.environment.apiUrl;
                    if (request.url.includes(this.removeProtocol(url))) {
                        request = request.clone({
                            setHeaders: {
                                Authorization: `Bearer ${token}`
                            }
                        });
                    }
                }
                return next.handle(request);
            })
        );
    }

    private removeProtocol = (str: string): string => str.replace(/^https?:\/\//, '');
}
